import React, { createRef } from 'react';
import { IonSearchbar, IonLoading, IonChip, IonButton, IonButtons, IonListHeader, IonCardHeader, IonCardContent, IonCardTitle, IonCardSubtitle, IonCard, IonFab, IonFabButton, IonIcon, IonContent, IonHeader, IonItem, IonLabel, IonList, IonPage, IonTitle, IonToolbar, withIonLifeCycle, IonSegment, IonSegmentButton } from '@ionic/react';
import '../styles/Studysets.scss';
import '../styles/Flashcards.scss';
import Storage from '../Storage';
import SQLStorage from '../SQLStorage';
import Utilities from '../Utilities';
import History from './History';
import GoalProgress from './GoalProgress';
import ReviewModal from './ReviewModal';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';

import NotificationsImg from '../images/notifications.png';
import QuizImg from '../images/quiz.png';
import FlashcardsImg from '../images/flashcards.png';

import NoSetsImage from '../images/splash.png';

import { albums, notifications, add, close, addCircle, star, school, syncCircle, closeCircle, checkmarkCircle, barbell, trendingUp, checkmarkDoneOutline, checkmarkOutline, playCircle, checkmarkDoneCircle, image, settings, ribbon, newspaper, bookmark, calendar, caretUpCircle, informationCircle, golf, hourglass, checkmark } from 'ionicons/icons';

import store from '../state/store';
import { connect, dispatch } from 'react-redux';
import { updateSets } from '../state/actions/Calendar'
import Flashcard from './Flashcard';
import FlashcardEditModal from './FlashcardEditModal';
import Splash from './Splash';
import { isPlatform } from '@ionic/react';

import { Device } from '@capacitor/device';
import { Keyboard } from '@capacitor/keyboard';
import { LocalNotifications } from '@capacitor/local-notifications';

let intervalDummy = null;

class Studysets extends React.Component {

    constructor(props) {
        super(props);
        this.pageRef = createRef();
        this.state = {
            studysets: [],
            studysetsFormatted: null,
            loading: true,
            dummy: 1,
            keywords: "",
            searchTags: [],
            openCardI: null,
            selectPracticeType: null,
            // historyModal: false,
            // historyModalTapCount: 0,
            showOnboarding: null,
            keyboardShowing: false,
            chunkSize: 0,
            showAllSearchResults: false,
            reviewModal: null,
        }

        if (isPlatform("ios") || isPlatform("android")) {

            // Keyboard.setResizeMode({mode:"body"}) // Keyboard.setResizeMode("body")

            Keyboard.addListener('keyboardWillShow', (info) => {
                this.setState({ keyboardShowing: true })
                window.keyboardHeight = info.keyboardHeight;
            });

            Keyboard.addListener('keyboardWillHide', () => {
                this.setState({ keyboardShowing: false })
            });

        }
    }

    handleFocus = () => {
        if (window.dropbox && (!localStorage.getItem("consolidateStorage"))) {
            window.dropbox.sync();
        }
    }

    async componentDidUpdate() {
        if (window.location.pathname.startsWith("/sets") && localStorage.getItem("justEndedPractice")) {
            if (this.blockedPracticeOpenAgain) {
                return;
            }
            this.blockedPracticeOpenAgain = true;
            setTimeout(() => {
                this.blockedPracticeOpenAgain = false
                Storage.remove("statsBeforePractice");
                localStorage.removeItem("justEndedPractice");
            }, 1000)

            let beforePractice = await Storage.getO("statsBeforePractice");
            let afterPractice = await Utilities.getReviewEndStats();
    
            if (beforePractice && afterPractice) {
                if (beforePractice.learnt === afterPractice.learnt && beforePractice.mastered === afterPractice.mastered && beforePractice.reviews === afterPractice.reviews && beforePractice.reviewedCardIdsToday === afterPractice.reviewedCardIdsToday ) { } else {
                    this.setState({
                        reviewModal: {
                            before: beforePractice,
                            after: afterPractice
                        }
                    })
                }
            }
        } else if (window.location.pathname.startsWith("/sets") && localStorage.getItem("openSet")) {
            const openSetId = localStorage.getItem("openSet");
            localStorage.removeItem("openSet");
            this.props.history.push("/studyset/" + openSetId)
        }
    }

    componentWillUnmount() {
        window.removeEventListener("focus", this.handleFocus);
    }

    componentWillMount() {
        intervalDummy = setInterval(function() {
            this.setState({ dummy: this.state.dummy + 1 })
        }.bind(this), 31000)
    }

    componentDidMount(calledNTimes) {
        // console.log("componentDidMount(" + calledNTimes + ")");

        if (!window.inited) {
            if (calledNTimes && calledNTimes > 60 && !window.showedUnsupportedBrowserDialogue) {
                localStorage.setItem("preventAppOpenTrack", "true")
                window.location.reload();
                return;
            }
            setTimeout(() => {
                this.componentDidMount(calledNTimes ? (calledNTimes+1) : 1);
            }, 100);
            return;
        }
        this.load();
        console.log("load()")
        window.addEventListener("focus", this.handleFocus);
    }

    async load () {

        let studysetCount, settings, syncEnabled, showOnboarding

        studysetCount = await SQLStorage.getStudysetCount();
        settings = await Storage.getO("settings");
        syncEnabled = settings && settings.dropbox !== undefined && settings.dropbox !== null;
        showOnboarding = (!syncEnabled && !studysetCount);

        console.log("_____ LOAD studysets", studysetCount, settings, syncEnabled, showOnboarding);

        if (showOnboarding) {
            const elements = document.getElementsByTagName("body");
            if (elements && elements[0]) {
                elements[0].classList = "tabs-hidden"
            }
        }
        
        this.setState({ showOnboarding: showOnboarding })
        let deviceInfo = await Device.getInfo();
        this.setState({ platform: deviceInfo.platform });

    }

    async createStudyset() {

        if (window.migrationNeeded) {
            alert("We have made some big changes to our app, you will need to back up your data to Dropbox (if you haven't already), delete the application, reinstall the application, and restore yours cards from Dropbox.")
            return;
        }

        Utilities.trackEvent("Studyset", "Studyset Create");

        let newId = "" + Utilities.getId();

        let newStudyset = {
            name: "",
            term: null,
            definition: null,
            createdAt: new Date(),
            updatedAt: new Date(),
            id: newId,
        }

        await SQLStorage.saveSet(newStudyset);
        await window.dropbox.queueForUpload("set", newId)

        this.props.history.push("/studyset/" + newId + "/justcreated")

    }

    openSet(id) {
        if (this.state.platform === "web") {
            this.props.history.push("/sets");
            setTimeout(function() {
                this.props.history.push("/studyset/" + id);
            }.bind(this), 350)
        } else {
            this.props.history.push("/studyset/" + id);
        }

    }

    async search() {
    
        if (this.state.keywords || this.state.searchTags.length !== 0) {
            Utilities.trackEvent("Flashcards", "Flashcards Global Search", this.state.keywords.trim().toLowerCase() + "|" + this.state.searchTags.join(","));
            let matches = await SQLStorage.searchCards(this.state.keywords.trim().toLowerCase(), this.state.searchTags);
            this.setState({ matches: matches.length === 0 ? null : matches})
        } else {
            this.setState({ matches: null })
        }

    }

    async setPracticeType(type, type2) {

        await Utilities.saveCurrentStats();

        let customFilters = this.state.searchTags;
        if (this.state.keywords) {
            customFilters.push("keywords:" + this.state.keywords);
        }

        await Storage.setO("lastPractice", {
            type: type,
            content: type2,
            filters: type2 === "custom" ? customFilters : [],
            total: this.state.selectedPracticeTypeNumber,
            chunk: this.state.chunkSize,
            chunkI: 0
        })

        if (type === "quiz") {
            this.props.history.push("/practice");
        } else if (type === "notifications") {
            let pending = await LocalNotifications.getPending();
            if (pending.notifications.length !== 0) {
                await LocalNotifications.cancel(pending);
            }
            await Storage.remove("notifications");
            this.props.history.push("/queue");
        } else if (type === "flashcards") {
            this.props.history.push("/flashcards");
        }

        this.setState({ selectPracticeType: null })

    }

    render() {

        const reduxStudysets = store.getState().calendar
        let studysetsFormatted = (reduxStudysets && reduxStudysets.studysetsFormatted) ? reduxStudysets.studysetsFormatted : null ;
        let tagReferencesBySet = (reduxStudysets && reduxStudysets.tagReferencesBySet) ? reduxStudysets.tagReferencesBySet : null ;
        let syncStatus = (reduxStudysets && reduxStudysets.syncStatus) ? reduxStudysets.syncStatus : "" ;
        let dueCards = (reduxStudysets && reduxStudysets.dueCards) ? reduxStudysets.dueCards : 0;
        let newCards = (reduxStudysets && reduxStudysets.newCards) ? reduxStudysets.newCards : 0;
        let masteredCards = (reduxStudysets && reduxStudysets.masteredCards) ? reduxStudysets.masteredCards : 0;
        let studyingCards = (reduxStudysets && reduxStudysets.studyingCards) ? reduxStudysets.studyingCards : 0;
        let learntCards = (reduxStudysets && reduxStudysets.learntCards) ? reduxStudysets.learntCards : 0;
        let lastPractice = (reduxStudysets && reduxStudysets.lastPractice) ? reduxStudysets.lastPractice : null;

        if (this.state.showOnboarding === null)
            return null;

        if (this.state.showOnboarding && !this.state.onboardingDismissed)
            return (
                <Splash onDismiss={() => { 
                    this.setState({ onboardingDismissed: true }) 
                    const elements = document.getElementsByTagName("body");
                    if (elements && elements[0]) {
                        elements[0].classList = ""
                    }
                }} />
            )

        return (
            <IonPage data-page="studysets" ref={this.pageRef}>
                { (!((!this.state.keywords && this.state.searchTags.length === 0) && studysetsFormatted && studysetsFormatted.length === 0)) &&
                    <IonHeader>
                        <IonToolbar>
                            <IonButtons slot="start">
                                { (syncStatus) ?
                                    <IonButton onClick={() => { window.dropbox.sync() }}>
                                        { (syncStatus && syncStatus.indexOf("Error") === -1 && syncStatus.indexOf("Updated") === -1 ) && <IonIcon style={{ fontSize: 10, width: 24 }} slot="start" className="rotate sync" icon={syncCircle} /> }
                                        { (syncStatus && syncStatus.indexOf("Error") !== -1 ) && <IonIcon slot="start" className="sync" style={{ color: "#fb5b5a", fontSize: 10, width: 24 }} icon={closeCircle} /> }
                                        { (syncStatus && syncStatus.indexOf("Updated") !== -1 ) && <IonIcon slot="start" className="sync" style={{ color: "#50d890", fontSize: 10, width: 24 }} icon={checkmarkCircle} /> }
                                        <p style={{ fontSize: 12, color: '#333' }} >{syncStatus.startsWith("Updated at") && this.state.dummy ? "Updated " + Utilities.timeSince(new Date(parseInt(syncStatus.replace("Updated at ", ""))*1000)) : syncStatus}</p>
                                    </IonButton>
                                    :
                                    null
                                }
                                {/*<IonButton onClick={() => { this.props.history.push("/settings") }}>
                                    <p>Sync is disabled</p>
                                </IonButton>*/}
                            </IonButtons>
                            <IonTitle onClick={() => {
                                // this.setState({ historyModalTapCount: this.state.historyModalTapCount + 1 })
                                // console.log(this.state.historyModalTapCount);
                                // if (this.state.historyModalTapCount > 5) {
                                //     this.setState({ historyModal: true })
                                // }
                            }}>{window.ln.sets}</IonTitle>
                        </IonToolbar>
                    </IonHeader>
                }
                <IonContent data-onboarding={(studysetsFormatted && studysetsFormatted.length === 0) ? "true" : "false"}>
                    { (studysetsFormatted && studysetsFormatted.length !== 0) &&
                        <div className="search-options">
                            <div>
                                <IonSearchbar
                                    debounce={700}
                                    id="search-bar"
                                    showCancelButton="focus"
                                    value={this.state.keywords}
                                    onIonChange={(e) => {
                                        console.log("@@ ionIonChange()")
                                        this.search();
                                    }}
                                    onKeyUp={(e) => {
                                        console.log("@@ onKeyUp()")
                                        this.setState({
                                            keywords: e.target.value.toLowerCase()
                                        })
                                    }}
                                    placeholder={window.ln.searchInAll}
                                    onIonClear={() => {
                                        this.setState({
                                            keywords: "",
                                            searchTags: []
                                        }, function() {
                                            this.search()
                                        })
                                    }}
                                />
                                <div className="tags">
                                    { reduxStudysets.tags.map(tag => {
                                        if (tag.id === "recording") return null;
                                        const tagName = (tag.id === "star") ? window.ln.starred : (tag.id === "studying" || tag.id === "new" || tag.id === "learnt" || tag.id === "image" || tag.id === "recording" || tag.id === "mastered") ? Utilities.capitalize(window.ln[tag.id]) : tag.name;
                                        return (
                                            <IonChip 
                                                data-ns={(this.state.searchTags.indexOf(tag.id) === -1 ? "true" : "false")} 
                                                key={tag.id} 
                                                data-color={tag.color}
                                                onClick={() => {
                                                    let searchTags = this.state.searchTags;
                                                    if (searchTags.indexOf(tag.id) === -1) {
                                                        searchTags.push(tag.id);
                                                    } else {
                                                        searchTags.splice(searchTags.indexOf(tag.id), 1);
                                                    }
                                                    this.setState({ searchTags: searchTags }, function() {
                                                        this.search();
                                                    })
                                                }}
                                            >
                                                { (tag.id === "star") && <IonIcon style={{ fontSize: '1.3em', position: 'relative', top: '-1px' }} icon={star}/> }
                                                { (tag.id === "studying") && <IonIcon icon={playCircle}/> }
                                                { (tag.id === "new") && <IonIcon icon={caretUpCircle}/> }
                                                { (tag.id === "learnt") && <IonIcon icon={checkmarkCircle}/> }
                                                { (tag.id === "mastered") && <IonIcon icon={checkmarkDoneCircle}/> }
                                                { (tag.id === "image") && <IonIcon icon={image}/> }
                                                <IonLabel>{tagName}</IonLabel>
                                            </IonChip>
                                        )
                                    }) }
                                </div>
                            </div>
                        </div>
                    }
                    { (this.state.keywords || this.state.searchTags.length !== 0) &&
                        <div 
                            className="search-wrapper"
                            style={{
                                height: 'unset'
                            }}
                        >
                            <h2 style={{
                                padding: "20px 0px 0px 2px",
                                margin: 0,
                                fontWeight: 700
                            }}>Flashcards</h2>
                            { ( (this.state.keywords || this.state.searchTags.length !== 0) && (!this.state.matches) ) &&
                                <div className="not-enough-keywords">
                                    <h2>{window.ln.noMatch}</h2>
                                </div>
                            }
                            {/* { (this.state.keywords && this.state.keywords.length < 3) &&
                                <div className="not-enough-keywords">
                                    <h2>{window.ln.atLeastThreeChars}</h2>
                                </div>
                            } */}
                            <div className="cards">
                                { (this.state.matches) && this.state.matches.map((item, i) => {
                                    if ( (!item.term) && (!item.definition) ) return null;
                                    if (!this.state.showAllSearchResults && i > 2) return null;
                                    return (
                                        <React.Fragment>
                                            <Flashcard
                                                onClick={ async () => { 
                                                    if (this.state.keyboardShowing) {
                                                        let el = document.querySelector(".search-options");
                                                        console.log(el);
                                                        if (el) {
                                                            el.click();
                                                            await new Promise((resolve) => { setTimeout(() => { resolve() }, 600) });
                                                        }
                                                    }
                                                    this.setState({ openCardI: i }) 
                                                }}
                                                tags={reduxStudysets.tags}
                                                flashcard={item} 
                                                i={i} 
                                                setName={item.setName}
                                                matchKeyword={this.state.keywords}
                                                definition={item.setDefinition} 
                                                term={item.setTerm} 
                                                definitionPronouncation={(window.globalVars.availableLanguages.indexOf(item.setDefinition) > -1)} 
                                                termPronouncation={(window.globalVars.availableLanguages.indexOf(item.setTerm) > -1)} 
                                            />
                                            { (i === 2 && !this.state.showAllSearchResults) &&
                                                <button 
                                                    className='main' 
                                                    onClick={() => {
                                                        this.setState({
                                                            showAllSearchResults: true                                                   
                                                        })
                                                    }}
                                                    style={{
                                                        marginTop: 15
                                                    }}
                                                >{window.ln.showAll}</button>
                                            }
                                        </React.Fragment>
                                    )
                                }) }
                            </div>
                        </div>
                    }
                    { (!studysetsFormatted || localStorage.getItem("consolidateStorage")) &&
                        <IonLoading
                            isOpen={this.state.loading}
                            message={localStorage.getItem("consolidateStorage") ? (window.ln.consolidatingStorage) : window.ln.loading}
                            duration={200000}
                        />
                    }
                    { ( (!this.state.keywords && this.state.searchTags.length === 0) && studysetsFormatted && studysetsFormatted.length === 0) && (!(syncStatus === "Retriving card indexes" || syncStatus.indexOf("Uploading") !== -1 || syncStatus.indexOf("Downloading") !== -1)) &&
                        <div className="onboarding-empty">
                            <div>
                                { (syncStatus === "Retriving card indexes" || syncStatus.indexOf("Uploading") !== -1 || syncStatus.indexOf("Downloading") !== -1) ? <h1>{window.ln.startingSync}</h1> : <h1>{window.ln.noSets}</h1> }
                                { (syncStatus === "Retriving card indexes" || syncStatus.indexOf("Uploading") !== -1 || syncStatus.indexOf("Downloading") !== -1) ? <p>{window.ln.startingSyncP}</p> : <p>{window.ln.noSetsP}</p> }
                                <button className="main" onClick={() => { this.createStudyset(); }}>{window.ln.createNewStudyset}</button>
                                <button onClick={() => {
                                    window.startDropboxAuth();
                                }}>{window.ln.restoreFromDropboxBackup}</button>
                                <button onClick={() => {
                                    localStorage.setItem("autoBackupImportPrompt", "true");
                                    this.props.history.push("/settings")
                                }}>{window.ln.restoreFromBackup}</button>
                                <button onClick={() => { this.props.history.push("/discover") }}>{window.ln.setStarterPacks}</button>
                            </div>
                        </div>
                    }
                    { ( (!this.state.keywords && this.state.searchTags.length === 0) && studysetsFormatted && studysetsFormatted.length !== 0) &&
                        <div className="activities-wrapper" style={{ backgroundColor: 'whitesmoke', padding: 15 }}>
                            <GoalProgress
                                lastPractice={lastPractice}
                                dueCards={dueCards}
                                masteredCards={masteredCards}
                                studyingCards={studyingCards}
                                learntCards={learntCards}
                                newCards={newCards}
                                onSelectPracticeType={(selectPracticeType, selectedPracticeTypeNumber) => {
                                    Utilities.onDrawerShow();
                                    this.setState({
                                        selectPracticeType: selectPracticeType,
                                        selectedPracticeTypeNumber: selectedPracticeTypeNumber,
                                        chunkSize: 10
                                    }, () => {
                                        Utilities.onDrawerShow();
                                    })
                                }}
                                {...this.props}
                            />
                        </div>
                    }
                    { ( /* (!this.state.keywords && this.state.searchTags.length === 0) && */ studysetsFormatted && studysetsFormatted.length !== 0) &&
                        <div 
                            className="sets"
                            style={ (this.state.keywords || this.state.searchTags.length !== 0) ? {
                                height: 'unset',
                                minHeight: 'unset'
                            } : { } }
                        >
                            { (this.state.keywords || this.state.searchTags.length !== 0)  &&
                                <h2 style={{
                                    padding: "20px 0px 0px 22px",
                                    margin: 0,
                                    fontWeight: 700
                                }}>Study sets</h2>
                            }
                            { (studysetsFormatted.map(item => {

                                if (this.state.keywords && (item.name ? item.name : "").toLowerCase().indexOf(this.state.keywords) === -1)
                                    return null;

                                let cardStates = {
                                    studying: 0,
                                    learnt: 0,
                                    new: 0,
                                    mastered: 0,
                                }

                                const itemTags = tagReferencesBySet ? tagReferencesBySet[item.id] : [];

                                if (itemTags) {
                                    for (let i = 0; i < itemTags.length; i++) {
                                        const tag = itemTags[i];
                                        if (tag.tagId === "studying") { cardStates.studying += tag.count }
                                        else if (tag.tagId === "new") { cardStates.new += tag.count }
                                        else if (tag.tagId === "learnt") { cardStates.learnt += tag.count }
                                        else if (tag.tagId === "mastered") { cardStates.mastered += tag.count }
                                    }
                                }

                                let totalCardStats = cardStates.studying + cardStates.learnt + cardStates.new + cardStates.mastered;
                                for (let key in cardStates) {
                                    cardStates[key] = Math.round(cardStates[key] / totalCardStats * 100) || 0;
                                }

                                return (
                                <IonCard 
                                    className="flashcard" 
                                    key={"set-" + item.id} 
                                    onClick={() => {
                                        if (window.migrationNeeded) {
                                            alert("We have made some big changes to our app, you will need to back up your data to Dropbox (if you haven't already), delete the application, reinstall the application, and restore yours cards from Dropbox.")
                                        } else {
                                            this.openSet(item.id)
                                        }   
                                    }}
                                >
                                    { (cardStates.new || cardStates.studying || cardStates.learnt || cardStates.mastered) ?
                                        <div className="progress">
                                            { cardStates.new ? <div style={{ backgroundColor: "#F9844A", width: cardStates.new + "%" }}></div> : null }
                                            { cardStates.studying ? <div style={{ backgroundColor: "#06D6A0", width: cardStates.studying + "%" }}></div> : null }
                                            { cardStates.learnt ? <div style={{ backgroundColor: "#118AB2", width: cardStates.learnt + "%" }}></div> : null }
                                            { cardStates.mastered ? <div style={{ backgroundColor: "#7579e7", width: cardStates.mastered + "%" }}></div> : null }
                                        </div>
                                        :
                                        null
                                    }
                                    { item.isSyncing && <IonIcon className="sync rotate" icon={syncCircle} /> }
                                    <p style={ (cardStates.new || cardStates.studying || cardStates.learnt || cardStates.mastered) ? { marginTop: 4 } : { } }>{item.name || window.ln.untitled}</p>
                                    <p>{item.count} cards {(item.definition && item.term) ? "(" + item.term + " - " + item.definition + ")" : ""} </p>
                                    { (itemTags && itemTags.length !== 0) &&
                                        <div className="tags">
                                            { itemTags.map(tag => {
                                                const tagName = (tag.tagId === "star") ? window.ln.starred : (tag.tagId === "studying" || tag.tagId === "new" || tag.tagId === "learnt" || tag.tagId === "image" || tag.tagId === "recording" || tag.tagId === "mastered") ? Utilities.capitalize(window.ln[tag.tagId]) : tag.tagName;
                                                return (
                                                    <IonChip key={tag.tagId} data-color={tag.tagColor}>
                                                        { (tag.tagId === "star") && <IonIcon style={{ fontSize: '1.3em', position: 'relative', top: '-1px' }} icon={star}/> }
                                                        { (tag.tagId === "studying") && <IonIcon icon={playCircle}/> }
                                                        { (tag.tagId === "new") && <IonIcon icon={caretUpCircle}/> }
                                                        { (tag.tagId === "learnt") && <IonIcon icon={checkmarkCircle}/> }
                                                        { (tag.tagId === "mastered") && <IonIcon icon={checkmarkDoneCircle}/> }
                                                        { (tag.tagId === "image") && <IonIcon icon={image}/> }
                                                        <IonLabel>
                                                            { tagName }
                                                            <span>{tag.count}</span>
                                                        </IonLabel>
                                                    </IonChip>
                                                    )
                                            }) }
                                        </div>
                                    }
                                </IonCard> )
                            } )) }
                        </div>
                    }
                    { (this.state.openCardI !== null) &&
                        <FlashcardEditModal
                            onNewTag={(tag) => { }}
                            open={this.state.matches[this.state.openCardI].id}
                            flashcard={this.state.matches[this.state.openCardI]}
                            defaultTerm={window.ln.term}
                            defaultDefinition={window.ln.def}
                            tags={reduxStudysets.tags}
                            updateTagReferences={(a, b) => { }}
                            onDelete={() => {
                                let matches = this.state.matches;
                                matches.splice(this.state.openCardI, 1)
                                this.setState({ matches: matches, openCardI: null, openCardNew: false })
                            }}
                            onClose={ async (changedCard) => {
                                if (changedCard) {
                                    let matches = this.state.matches;
                                    matches[this.state.openCardI] = JSON.parse(JSON.stringify(changedCard))
                                    this.setState({ matches: matches })
                                }
                                this.setState({ openCardI: null, openCardNew: false })
                            }}
                        />
                    }
                    { (!(studysetsFormatted && studysetsFormatted.length === 0) && !this.state.keywords) &&
                        <IonFab vertical="bottom" horizontal="start" slot="fixed" style={{ width: "calc(100% - 20px)", display: "flex", justifyContent: "center", marginBottom: 10 }}>
                            <IonFabButton style={{ width: 184, '--border-radius': '56px' }} onClick={() => { this.createStudyset(); }}>
                                <IonIcon icon={addCircle} />
                                <IonLabel style={{ marginLeft: 8, fontWeight: 600, position: "relative", top: -1 }}>{window.ln.createNewStudyset}</IonLabel>
                            </IonFabButton>
                        </IonFab>   
                    }
                    { (this.state.keywords || this.state.searchTags.length !== 0) &&
                        <IonFab vertical="bottom" horizontal="start" slot="fixed" style={{ width: "calc(100% - 20px)", display: "flex", justifyContent: "center", marginBottom: 10 }}>
                            { (this.state.matches && this.state.matches.length !== 0) &&
                                <IonFabButton style={{ width: 140, '--border-radius': '56px', marginRight: 15,  }} onClick={() => {
                                    this.setState({
                                        selectPracticeType: "custom",
                                        selectedPracticeTypeNumber: this.state.matches.length,
                                        chunkSize: 10
                                    }, () => {
                                        Utilities.onDrawerShow();
                                    })
                                }}>
                                    <IonIcon icon={school} />
                                    <IonLabel style={{ marginLeft: 8, fontWeight: 600, position: "relative", top: -1 }}>{window.ln.practice + " " + this.state.matches.length}</IonLabel>
                                </IonFabButton>
                            }
                            <IonFabButton style={{ width: 140, '--border-radius': '56px', '--background': '#fb5b5a' }} onClick={() => {
                                this.setState({
                                    keywords: "",
                                    searchTags: []
                                }, function() {
                                    this.search()
                                })
                            }}>
                                <IonIcon icon={closeCircle} />
                                <IonLabel style={{ marginLeft: 8, fontWeight: 600, position: "relative", top: -1 }}>{window.ln.clearFilters}</IonLabel>
                            </IonFabButton>
                        </IonFab>   
                    }
                </IonContent>
                <SwipeableDrawer
                    anchor="bottom"
                    open={this.state.selectPracticeType !== null}
                    key="flashcard-editor"
                    transitionDuration={0}
                    className="type-selector"
                    onOpen={ () => {
                        Utilities.onDrawerShow();
                    } }
                    onClose={ () => { 
                        Utilities.onDrawerHide();
                        this.setState({ selectPracticeType: null }) 
                    } }
                >
                    <div data-keyboard-showing={this.state.keyboardShowing} ref={this.modalRef} className="swipeable-drawer-body" className="type-selector-modal" style={{ 
                        position: "absolute",
                        bottom: 0,
                        width: "100%",
                        padding: 15,
                        background: "white",
                        borderRadius: '24px 24px 0 0'
                    }} >
                        <div className="drag-indicator"></div>
                        <h2 style={{ textAlign: "center", marginBottom: 12, fontSize: '1em', fontWeight: 700 }}>
                            {window.ln.selectPracticeType + ' '}
                            { window.ln.forXYCards.replace("__", this.state.matches ? this.state.matches.length : this.state.selectedPracticeTypeNumber). replace("___", this.state.selectPracticeType) }
                            {', '}
                            { (this.state.selectPracticeType === "new") ?
                                window.ln.sortHintNew :
                                (this.state.selectPracticeType === "due") ?
                                    window.ln.sortHintDue :
                                    window.ln.sortHintOther
                            }
                        </h2>
                        <div className="drag-close-indicator" onClick={() => {
                            Utilities.onDrawerHide();
                            this.setState({ selectPracticeType: null }) 
                        }}>
                            <IonIcon icon={closeCircle} />
                        </div>
                        { (this.state.selectedPracticeTypeNumber > 10) &&
                            <div className='chunks'>
                                <h3>{window.ln.cardsPerRound}</h3>
                                <IonSegment value={this.state.chunkSize.toString()} onIonChange={e => {
                                    this.setState({
                                        chunkSize: parseInt(e.detail.value),
                                    })
                                }}>
                                    <IonSegmentButton value="10">
                                        <IonLabel>10</IonLabel>
                                    </IonSegmentButton>
                                    { (this.state.selectedPracticeTypeNumber >= 20) &&
                                        <IonSegmentButton value="20">
                                            <IonLabel>20</IonLabel>
                                        </IonSegmentButton>
                                    }
                                    { (this.state.selectedPracticeTypeNumber >= 30) &&
                                        <IonSegmentButton value="30">
                                            <IonLabel>30</IonLabel>
                                        </IonSegmentButton>
                                    }
                                    { (this.state.selectedPracticeTypeNumber >= 40) &&
                                        <IonSegmentButton value="40">
                                            <IonLabel>40</IonLabel>
                                        </IonSegmentButton>
                                    }
                                    { (this.state.selectedPracticeTypeNumber >= 50) &&
                                        <IonSegmentButton value="50">
                                            <IonLabel>50</IonLabel>
                                        </IonSegmentButton>
                                    }
                                </IonSegment>
                            </div>
                        }
                        <div className="drag-close-indicator" onClick={() => {
                            Utilities.onDrawerHide();
                            this.setState({  selectPracticeType: null }) 
                        }}>
                            <IonIcon icon={closeCircle} />
                        </div>
                        {/* <IonIcon onClick={() => { this.setState({  selectPracticeType: null }) }} icon={closeCircle} style={{ position: "absolute", top: 0, right: 0, padding: "9px 12px", fontSize: 24 }} /> */}
                        <div className="activities-wrapper select-type">
                            <div>
                                <div data-disabled={dueCards === 0 && this.state.selectPracticeType === "due" || newCards === 0 && this.state.selectPracticeType === "new"} style={{ backgroundColor: "#1D6AE5" }} data-activity="cards" onClick={() => { 
                                    if (dueCards === 0 && this.state.selectPracticeType === "due" || newCards === 0 && this.state.selectPracticeType === "new") { } else {
                                        this.setPracticeType("flashcards", this.state.selectPracticeType) 
                                    }  
                                }}>
                                    <img src={FlashcardsImg} />
                                    <div>
                                        <p>
                                            <strong>{window.ln.flashcards}</strong>
                                            {window.ln.flashcardsWhen}
                                        </p>
                                    </div>
                                </div>
                                <div data-disabled={dueCards === 0 && this.state.selectPracticeType === "due" || newCards === 0 && this.state.selectPracticeType === "new"} style={{ backgroundColor: "#7536EF" }} data-activity="queue" onClick={() => { 
                                    if (dueCards === 0 && this.state.selectPracticeType === "due" || newCards === 0 && this.state.selectPracticeType === "new") { } else {
                                        this.setPracticeType("notifications", this.state.selectPracticeType) 
                                    }
                                }}>
                                    <img src={NotificationsImg} />
                                    <div>
                                        <p>
                                            <strong>{window.ln.notifications}</strong>
                                            {window.ln.notificationsWhen}
                                        </p>
                                    </div>
                                </div>
                                <div data-disabled={dueCards === 0 && this.state.selectPracticeType === "due" || newCards === 0 && this.state.selectPracticeType === "new"} style={{ backgroundColor: "#2dce91" }} data-activity="practice" onClick={() => { 
                                    if (dueCards === 0 && this.state.selectPracticeType === "due" || newCards === 0 && this.state.selectPracticeType === "new") { } else {
                                        this.setPracticeType("quiz", this.state.selectPracticeType) 
                                    }   
                                }}>
                                    <img src={QuizImg} />
                                    <div>
                                        <p>
                                            <strong>{window.ln.quiz}</strong>
                                            {window.ln.quizWhen}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        { ((dueCards === 0 && this.state.selectPracticeType === "due") || (newCards === 0 && this.state.selectPracticeType === "new")) &&
                            <p>{ (dueCards === 0 && this.state.selectPracticeType === "due") ? window.ln.noDueCards : window.ln.noNewCards } </p>
                        }
                    </div>
                </SwipeableDrawer>
                {/* { (this.state.historyModal) &&
                    <History 
                        open={this.state.historyModal}
                        onDidDismiss={() => { this.setState({ historyModal: false }) }}
                    />
                } */}
                <ReviewModal
                    {...this.props}
                    data={this.state.reviewModal}
                    onClose={() => { this.setState({ reviewModal: null })  }}
                />
            </IonPage>
        );
    }

};


export default withIonLifeCycle(connect(function mapStateToProps(state, ownProps) {
    return {
        ...ownProps,
        ...state,
    };
})(Studysets));
